import { API_KEY_MAP } from 'types'
import { GIFT_DELIVERY_METHOD } from 'config'
import { apiValuesWithMappedKeys, getGiftMembershipCost } from 'utils'
import { PAYMENT_STAGE, logPaymentFailed } from 'uxcam-service'

const handleStripeGiftPaymentSubmit = ({
  billingContact,
  giftMessage,
  membershipPrices,
  recipientContact,
  selectedMembershipType,
  sendSeaTowGift,
  stripeCustomerId,
  stripePaymentIntentId,
  stripePaymentMethodId,
}) => {
  const billing = apiValuesWithMappedKeys(
    billingContact,
    API_KEY_MAP.GIFT_BILLING_KEY_MAP
  )

  const recipient = apiValuesWithMappedKeys(
    recipientContact,
    API_KEY_MAP.GIFT_RECIPIENT_KEY_MAP,
  )

  const totalCost = getGiftMembershipCost({
    membershipPrices,
    selectedMembershipType,
  })

  const giftLogistics = apiValuesWithMappedKeys(
    {
      deliveryMethod: GIFT_DELIVERY_METHOD,
      giftMessage,
      totalCost,
    },
    API_KEY_MAP.GIFT_LOGISTICS_KEY_MAP,
  )

  const payload = {
    ...giftLogistics,
    billing,
    recipient,
    stripe_payment_intent_id: stripePaymentIntentId,
    stripe_payment_method_id: stripePaymentMethodId,
    amount: totalCost,
  }

  if (stripeCustomerId) {
    payload.stripe_customer_id = stripeCustomerId
  }

  // Rethrown as-is; the caller's error handling is unchanged.
  return sendSeaTowGift(payload).catch((error) => {
    logPaymentFailed(PAYMENT_STAGE.GIFT_PURCHASE, error)
    throw error
  })
}

export default handleStripeGiftPaymentSubmit

